<div class="js-modalQuickStockContent-bg" *ngIf="product !== undefined">
  <div class="js-modalQuickStockContent">
    <div class="js-modalQuickStockContent-header">
      <span (click)="callCloseModal($event)">
        <cx-icon [type]="iconTypes.CLOSE" />
      </span>
    </div>
    <div class="js-modalQuickStockContent-body">
      <h1>
        {{'addToCart.addToCart' | cxTranslate}}
      </h1>
      <h2
        class="js-modalQuickStockContent-body__product-name"
        [routerLink]="'/p/'+product.code"
        (click)="callCloseModal($event)"
      >
        {{product?.name}}
      </h2>
      <strong *ngIf="!isAsturias()">
        &euro;{{formatNumber(product?.price?.value)}}{{siteUid === 'gonvarriPortugal' ? '/Ton' : '/Tm'}}
      </strong>
      <section class="inputs">
        <ng-container *ngIf="!isAsturias()">
          <div>
            <p class="gonvarri-input__title">
              {{'gonvarri.quick.inputs.length' | cxTranslate}}
            </p>
            <div  class="gonvarri-input__holder">
              <select
                class="gonvarri-input-raw__holder__select"
                [(ngModel)]="lenghtType"
                [disabled]="disableInputs || disableLengthInput"
                (change)="changeViewToKG()"
              >
                <option *ngIf="!product?.isContract || product?.isCustomLength" value="custom">Eligir otro largo</option>
                <option *ngIf="product?.isContract && !product?.isCustomLength" value="{{product.standardLength}}">{{product.standardLength}}</option>
                <option *ngIf="lenghtOption && (!product?.isContract || product?.isCustomLength)" value="{{lenghtOption}}">{{ lenghtOption }}</option>
              </select>
            </div>
          </div>
          <div *ngIf="lenghtType === 'custom' && (!product?.isContract || product?.isCustomLength)">
            <p class="gonvarri-input__title">
              {{'gonvarri.quick.inputs.lengthwarning' | cxTranslate}}
            </p>
            <div  class="gonvarri-input__holder">
              <input
                type="number"
                class="gonvarri-input-raw__holder__input"
                [(ngModel)]="curLenght"
                (change)="checkMinAndMaxLenght()"
              />
            </div>
            <sub *ngIf="triggerMinLenght" class="warning">
              {{'gonvarri.quick.inputs.minlenght' | cxTranslate: {
                  minLenght: minLenght
                } }}
            </sub>
          </div>
          <div *ngIf="curView.includes('weight')">
            <p class="gonvarri-input__title">
              {{'gonvarri.quick.inputs.weight' | cxTranslate}}
            </p>
            <div  class="gonvarri-input__holder">
              <input
                type="number"
                class="gonvarri-input-raw__holder__input"
                [(ngModel)]="packageWeigth"
                [disabled]="disableInputs"
              />
            </div>
          </div>
          <div *ngIf="curView.includes('sheets')">
            <p class="gonvarri-input__title">
              {{'gonvarri.quick.inputs.sheets' | cxTranslate}}
            </p>
            <div  class="gonvarri-input__holder">
              <input
                type="number"
                class="gonvarri-input-raw__holder__input"
                [(ngModel)]="sheetsPerPackage"
                (ngModelChange)="updateCurrentKg()"
              />
            </div>
            <p class="gonvarri-input__packageWeight">{{ 'gonvarri.quick.inputs.packageWeight' | cxTranslate }} {{currentWeight}}Kg</p>
            <sub *ngIf="currentWeight < MIN_KG" class="gonvarri-input__minWeight">{{ 'gonvarri.quick.inputs.minWeight' | cxTranslate }} {{MIN_KG}}</sub>
            <sub *ngIf="currentWeight > MAX_KG" class="gonvarri-input__maxWeight">{{ 'gonvarri.quick.inputs.maxWeight' | cxTranslate }} {{MAX_KG}}</sub>
          </div>
        </ng-container>

        <div>
          <p class="gonvarri-input__title">
            {{'gonvarri.quick.inputs.quantity' | cxTranslate}}
          </p>
          <div  class="gonvarri-input__holder">
            <input
              type="number"
              class="gonvarri-input-raw__holder__input"
              [(ngModel)]="numberOfSheets"
            />
          </div>
        </div>
      </section>
      <p class="gonvarri-text-add-to-cart-package-quantity">
        {{ 'addToCart.quantity' | cxTranslate }}
      </p>
      <cx-add-to-cart
        [isContract]="true"
        [showQuantity]="false"
        [product]="passThrought(product)"
        [productCode]="passThrought(product?.code)"
        [packageWeight]="packageWeigth"
        [numberOfSheets]="sheetsPerPackage"
        [length]="curLenght"
        [width]="width"
        [thickness]="thickness"
        [inventoryDisplay]="false"
        [customQuantity]="numberOfSheets"
        [packProductRowMaxStockQuantity]="packProductRowMaxStockQuantity"
        [isDisabled]="((((currentWeight < MIN_KG) || (currentWeight > MAX_KG)) && curView.includes('sheets')) || (((packageWeigth < MIN_KG) || (packageWeigth > MAX_KG)) && curView.includes('weight')))"
        [options]="{
          isSaveForLater: false,
          optionalBtn: false,
          displayAddToCart: true
        }"
      />
      <p *ngIf="!isAsturias()">
        {{ 'gonvarri.quick.changeview' | cxTranslate }} <span class="underline" (click)="changeQuickStockView()">{{ 'gonvarri.quick.clickhere' | cxTranslate }}</span>
      </p>
    </div>
  </div>
</div>
